import { useQuery } from '@tanstack/react-query'
import apiV2 from '../../service/apiV2.service'
import { InvoiceV2DetailedType } from '../../types/ApiV2'
import useReactQueryErrorEffect from './useReactQueryErrorEffect'

const useReactQueryInvoice = () => {
  const {
    data: invoiceResponse,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['invoices', 'unpaid'],
    queryFn: () => apiV2.getUnpaidInvoices(),
  })

  useReactQueryErrorEffect(error)

  return {
    unpaidInvoices: invoiceResponse?.data ?? ([] as InvoiceV2DetailedType[]),
    availableProductTypes: invoiceResponse?.availableProductTypes ?? ([] as string[]),
    isLoading,
    isError,
  }
}

export default useReactQueryInvoice
